import configs from "@/features/menu/configs";
import { addRoutesFromConfig } from "@/router";

export const addRoutes = () => addRoutesFromConfig(configs);
